import { __assign, __extends } from "tslib";
import React from "react";
import PropTypes from "prop-types";
import PnmacLoanSwitcherMenu from "./PnmacLoanSwitcherMenu";
import PnmacLoanSwitcherTabs from "./PnmacLoanSwitcherTabs";
var PnmacLoanSwitcher = /** @class */function (_super) {
  __extends(PnmacLoanSwitcher, _super);
  function PnmacLoanSwitcher() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      openModal: false
    };
    return _this;
  }
  PnmacLoanSwitcher.prototype.render = function () {
    return this.props.row ? (/*#__PURE__*/React.createElement(PnmacLoanSwitcherTabs, __assign({
      testID: "loanSwitcher"
    }, this.props))) : (/*#__PURE__*/React.createElement(PnmacLoanSwitcherMenu, __assign({
      testID: "loanSwitcher"
    }, this.props)));
  };
  return PnmacLoanSwitcher;
}(React.Component);
PnmacLoanSwitcher.propTypes = {
  loanIds: PropTypes.array,
  onValueChange: PropTypes.func,
  selectedValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  address: PropTypes.string
};
export default PnmacLoanSwitcher;